import React from "react"
import { Heading, Text, VStack, Box, Image, Button } from "@chakra-ui/react"
import { useRouteLoaderData, Link } from "react-router-dom"
import GradientBox from "./GradientBox"
import { getStripePricingTableEmbedConfig } from "../lib/stripePricingEmbed"
import { addAlert, removeAlertBySource, AlertType } from "../lib/alerts"
import Logo from "../images/horizontal-light.svg"

const { publishableKey, pricingTableId } = getStripePricingTableEmbedConfig()

const PLAN_LIMIT_ALERT_SOURCE = "Plan limit"

const PLAN_LIMIT_ALERT_BODY =
  "You've reached your plan limit. Upgrade to get back to work — no data migration, instant access."

function FullBleed({ children }) {
  return (
    <Box
      w="100vw"
      maxW="100vw"
      position="relative"
      left="50%"
      transform="translateX(-50%)"
      mt={{ base: 6, md: 8 }}
    >
      {children}
    </Box>
  )
}

export default function ChoosePlan() {
  const user = useRouteLoaderData("auth")

  React.useEffect(() => {
    removeAlertBySource(PLAN_LIMIT_ALERT_SOURCE)
    addAlert(AlertType.WARNING, PLAN_LIMIT_ALERT_SOURCE, PLAN_LIMIT_ALERT_BODY)
    return () => {
      removeAlertBySource(PLAN_LIMIT_ALERT_SOURCE)
    }
  }, [])

  return (
    <GradientBox
      showLogo={false}
      minH="100vh"
      w="100%"
      alignItems="stretch"
      gap={{ base: 3, md: 4 }}
      p={0}
      pt={{ base: 3, md: 4 }}
      px={{ base: 4, md: 8 }}
      pb={0}
    >
      <Image
        src={Logo}
        alt="Blind Insight Logo"
        maxW={{ base: "9rem", md: "11rem" }}
        w="100%"
        objectFit="contain"
        alignSelf="flex-start"
      />

      <VStack align="stretch" spacing={{ base: 2, md: 3 }} w="100%">
        <Heading variant="standard">Pick up where you left off</Heading>
        <Text variant="subtext">
          Your datasets and schemas are still up there. Select a plan to restore
          access right away.
        </Text>
        <Button
          as={Link}
          to="/logout"
          variant="outline"
          size="sm"
          alignSelf="flex-start"
          borderColor="whiteAlpha.700"
          color="white"
          _hover={{ bg: "whiteAlpha.200" }}
          _active={{ bg: "whiteAlpha.300" }}
        >
          Log out
        </Button>
      </VStack>

      <FullBleed>
        <Box
          bg="white"
          pt={{ base: 6, md: 8 }}
          px={{ base: 4, md: 6, lg: 8 }}
          pb={{ base: 10, md: 14 }}
          w="100%"
        >
          <stripe-pricing-table
            width="100%"
            style={{
              display: "block",
              width: "100%",
              minHeight: "min(58vh, 640px)",
            }}
            pricing-table-id={pricingTableId}
            publishable-key={publishableKey}
            customer-email={user.email}
            client-reference-id={user.id}
          />
        </Box>
      </FullBleed>
    </GradientBox>
  )
}
